import parse from 'date-fns/parse';

const STEP = 30;
const DAY_MINUTES = 24 * 60;

// The open window of a BusinessDay slot (`hh:mm a` strings), in minutes from
// midnight; null for a closed day, which has no room for a break.
export const openWindowFor = slot => {
  if (slot.openAllDay) return { open: 0, close: DAY_MINUTES };
  if (!slot.from || !slot.to) return null;

  const minutesOf = time => {
    const date = parse(time, 'hh:mm a', new Date());
    return date.getHours() * 60 + date.getMinutes();
  };
  // BusinessDay offers 12:00 AM as a closing time, meaning midnight.
  const close = minutesOf(slot.to) || DAY_MINUTES;
  return { open: minutesOf(slot.from), close };
};

// The half-hour steps a break may start or end on: strictly inside the window,
// since a break touching either end would just be shorter opening hours. This
// is the same rule the backend enforces (see Custom::Concerns::WorkingHour).
export const breakOptions = openWindow => {
  const steps = [];
  for (
    let minute = openWindow.open + STEP;
    minute < openWindow.close;
    minute += STEP
  ) {
    steps.push(minute);
  }
  return steps;
};

export const isValidBreak = (value, openWindow) => {
  if (!value) return true;
  if (!openWindow) return false;

  const options = breakOptions(openWindow);
  return (
    value.start < value.end &&
    options.includes(value.start) &&
    options.includes(value.end)
  );
};
